const SORT_ORDER = {
  TITLE: 'title',
  EMAIL: 'email',
  DESCRIPTION: 'description',
  NAME: 'name',
  PERIOD: 'time_remaining',
  AMOUNT: 'amount',
  CREATED_AT: 'created_at',
  STATUS: 'status',
  PAYMENT_COUNT: 'payment_count',
  CURRENCY: 'currency',
  COIN_ID: 'coin_id',
  RECEIVED_AMOUNT: 'received_amount',
  REQUESTS_COUNT: 'requests_count',
  SWAP_ALL_COUNTS: 'swap_all_counts',
  SORT_SUCCESSFUL_COUNTS: 'swaps_successful_counts',
  UNIQUE_VISITS: 'unique_visits',
  TOTAL_AMOUNT: 'total_amount',
  APPROVED_SUM: 'approved_sum',
  APPROVED_COUNT: 'approved_count',
  PAID_COUNT: 'paid_count',
  PAID_SUM: 'paid_sum',
  INVITED_COUNT: 'invited_count',
  FAILED_PAYS_COUNT: 'failed_pays_count',
  RAW_ERROR_COUNT: 'raw_error_count',
  IN_EMCD_COUNT: 'in_emcd_count',
  IN_EMCD_SUM: 'in_emcd_sum',
  PENDING_COUNT: 'pending_count',
  PENDING_SUM: 'pending_sum',

  PAYMENT_AMOUNT: 'payment_amount',
  PAID_AMOUNT: 'paid_amount',
  PAYMENT_DUE: 'payment_due',
  RECEIVED: 'received',
  BUYER_EMAIL: 'buyer_email',

  CONTRACTOR_STATUS: 'contractor_status',
  PAYMENT_STATUS: 'payment_status',
  NUMBER: 'number',
  UPDATED_AT: 'updated_at',

  NOTE: 'note',
}

export { SORT_ORDER }
